import { Injectable } from "@angular/core";
import { HomesFacade } from '@library/store/homes/homes.facade';
import { AutoTempModes, CoolingModes, TemperatureControlModes, ThermModes } from '@library/store/homes/homes.interface';
import * as moment from 'moment-timezone';
import { BehaviorSubject, Subject, merge } from "rxjs";

@Injectable()
export class SidebarControlModeService {

  selectMode$ = new Subject<ThermModes | CoolingModes | AutoTempModes>();
  thermMode$ = merge(
    this.selectMode$,
    this.homesFacade.thermMode$,
  );
  coolingMode$ = merge(
    this.selectMode$,
    this.homesFacade.coolingMode$,
  );
  autoTempMode$ = merge(
    this.selectMode$,
    this.homesFacade.autoTempMode$,
  );

  selectTemperatureControlMode$ = new Subject<TemperatureControlModes>();
  temperatureControlMode$ = merge(
    this.homesFacade.temperatureControlMode$,
    this.selectTemperatureControlMode$,
  );

  selectedEndDate$: BehaviorSubject<moment.Moment> = new BehaviorSubject(null);
  selectedEndTime$: BehaviorSubject<number> = new BehaviorSubject(null);

  dateErrors$ = new BehaviorSubject(null);

  constructor(
    private homesFacade: HomesFacade,
  ) {}

}